import { $http } from '@/plugins/common/http';

export const pushEvent = (data) => {
    return $http.post('/meta/events', data);
};
